module.exports = __webpack_public_path__ + "img/hr-water-green-outer-corner.8911bdd3.png";